export default __webpack_public_path__ + "static/media/TNG.8de42569.svg";